"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "verolengo": {
    "5ac8560d": [{
      "hkey": "967f88cc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-benne": [{
      "hkey": "967f88cc",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a32abfcd": [{
      "hkey": "6a00589b",
      "slug": "rolandini-sbarro-valentino",
      "name": "Rolandini-Sbarro Valentino",
      "primary": true,
      "skipSearch": false
    }],
    "rolandini": [{
      "hkey": "6a00589b",
      "slug": "rolandini-sbarro-valentino",
      "name": "Rolandini-Sbarro Valentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5dcc5a0d": [{
      "hkey": "6a00589b",
      "slug": "rolandini-sbarro-valentino",
      "name": "Rolandini-Sbarro Valentino",
      "primary": true,
      "skipSearch": false
    }],
    "sbarro-valentino": [{
      "hkey": "6a00589b",
      "slug": "rolandini-sbarro-valentino",
      "name": "Rolandini-Sbarro Valentino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;